module.exports = __webpack_public_path__ + "static/media/part1.0d6fd873.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/partners/part1.png
// module id = 102
// module chunks = 0